__turbopack_context__.v({
  "card": "BNCB8G_card",
  "cardBack": "BNCB8G_cardBack",
  "hoverPreview": "BNCB8G_hoverPreview",
  "loader": "BNCB8G_loader",
  "tapCatcher": "BNCB8G_tapCatcher",
  "tappable": "BNCB8G_tappable",
});
